module.exports = {};



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/_iterators.js
 ** module id = 544
 ** module chunks = 1
 **/